import { useMemo } from "react"

import { userTypes } from "@utils/contactUtils"

// PICKER-FREQ fix: address-book contacts (bookContacts, from GET /v1/users/me/contacts via
// devContactToBeta) carry NO `.count` at all -- only the CooWe-directory-derived contacts
// (cooweContacts, from getContactsWithTags' frequent/recent arrays, ultimately devDirUser's
// `count: u.shared_teeups`) do. List.js's "Frequent" sort (teeupUtils.frequentSorting) does
// `b.count - a.count`; an address-book row with count===undefined produces NaN and sorts
// arbitrarily, so the SAME contact whose People-page row correctly ranks #1 by shared-TeeUp
// count (Directory.js) could render anywhere in the invite picker's "Contacts"/"All" tabs. This
// mirrors PEOPLE-GRID BUG1 exactly (an address-book row never carried a real count) -- fix it the
// same way: match every book contact to its directory entry by normalized display name (book
// contacts carry no CooWe user id to join on) and attach the real count unconditionally.
const normalizeName = name => (name || "").trim().toLowerCase()

export const useFilteredContacts = (bookContacts, cooweContacts) => {
  const filterContacts = (contacts, countByName) => {
    return contacts?.reduce((acc, currentContact) => {
      // BUG (web people-picker zero-matches): the dev backend's CooWeverse directory
      // (/v1/directory) does not expose emails/phones for other tenant users (privacy-scoped —
      // unlike the old beta backend, which always populated at least one contact mechanism on a
      // directory row). Requiring emails.length || phoneNumbers.length silently dropped EVERY
      // real CooWe app user (type COO_E) from the picker, leaving only address-book contacts —
      // so any search for an existing app user (e.g. "maya") returned zero matches even though
      // the API call succeeded and the user was in the response. Known app users are identified
      // by id/username, not by a contact mechanism, so they don't need one to be listed.
      const isKnownCooeUser = currentContact?.type === userTypes.COO_E
      if (
        currentContact?.name?.trim()?.length &&
        currentContact?.username !== "Deleted Account" &&
        !acc?.some(contact => contact?.id === currentContact?.id) &&
        (currentContact?.emails?.length ||
          currentContact?.phoneNumbers?.length ||
          isKnownCooeUser)
      ) {
        const matched = countByName?.get(normalizeName(currentContact.name))
        acc.push(
          countByName && typeof currentContact.count !== "number"
            ? { ...currentContact, count: matched || 0 }
            : currentContact
        )
      }

      return acc
    }, [])
  }

  return useMemo(() => {
    // Real shared-TeeUp counts only ever land on the directory-derived list (cooweContacts) --
    // build the name -> count lookup from it so book contacts inherit the same signal the
    // People page already uses.
    const countByName = new Map()
    ;(cooweContacts || []).forEach(c => {
      if (typeof c?.count === "number" && c?.name) {
        countByName.set(normalizeName(c.name), c.count)
      }
    })
    return {
      filteredBookContacts: filterContacts(bookContacts, countByName),
      filteredCooweContacts: filterContacts(cooweContacts),
    }
  }, [bookContacts, cooweContacts])
}
